// Field-level selectors for the cabin-list container.
export const selectSiteSettings = (state) => state.common.siteSettings;
export const selectUserId = (state) => state.common.userId;
export const selectAccommodation = (state) => state.accommodation;
export const selectCruise = (state) => state.cruise;
export const selectIsInitialized = (state) => state.cruise.initialized;
export const selectPriceDetails = (state) => state.cruise.priceDetails;
export const selectLabels = (state) => state.labels;
export const selectMessage = (state) => state.message;
export const selectSearchInformation = (state) => state.searchInformation;
export const selectTransport = (state) => state.transport;
